import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Page,
  Card,
  Layout,
  SkeletonBodyText,
  BlockStack,
  Badge,
  Toast,
  Button,
  Modal,
  Icon,
  Tooltip,
  Text,
  // Link, Banner,
} from "@shopify/polaris";

import { QuestionCircleIcon } from "@shopify/polaris-icons";

import AppBridge from "../../../../utils/appBridge";

import NavTabs from "../components/NavTabs";
import {
  reqGetUserSettings,
  reqGetDisconnect,
  reqPostDisConnetPayPal,
  getPayonnerAuth,
  getPayonnerAuthOff,
} from "../../../../api";

import intl from "../../../../i18n/intl";
import "./index.css";
import { store } from "../../../../store";
import { changeBannerData } from "../../../../slice";

class ProfileClass extends Component {
  state = {
    ShopOwner: "",
    UserEmail: "",
    isFocusEmail: false,

    AccountName: "",
    AccountEmail: "",
    ResetPasswordActive: false,
    hidePassword: true,
    hideNewPassword: true,
    hideConfirmPassword: true,
    oldPasswordError: "",
    newPasswordError: "",
    confirmPasswordError: "",
    resetPasswordLoading: false,

    ChangeAccountEmailActive: false,
    sendCodeLoading: false,
    verifyLoading: false,
    NewEmailAddress: "",
    newEmailAddressError: "",
    VerifyCode: "",
    verifyCodeError: "",

    StoreName: "",
    // AliExpressId: '',
    // isAuth: true,
    // isExpire: false,
    // ExpireTime: 0,

    //弹窗
    showToast: false, //弹窗显示
    showToastText: "", //弹窗文字
    showToastIserror: false, //弹窗是否错误

    loadingPage: true,
    saveDataLoading: false,
    disabledSaveData: true,

    AuthButtonDisable: false,
    disconnectActive: false,

    // PayPal账户数据
    PayPalUserData: {
      email: "",
      status: 0,
      is_effective: 0,
      authUrl: "",
    },
    // Payoneer 账户数据
    PayoneerData: {
      account_id: "",
      email: "",
      expire_time: 0,
      status: 0,
    },

    disconnectType: 0, // 取消类型：1：速卖通 2：PayPal
    isLanguageChange: false,
    shopify_permission_upgrade: false,
    need_to_upgrade_permission: false,
    needSetPasswordActive: false,
    payonnerButton: false, //按钮加载状态
    payonnerLink: "", //授权链接
    payonnerOff: false, //取消授权
    payonnerOffLoading: false, //取消授权加载状态
  };

  //进入页面调用接口
  componentDidMount() {
    this.getUserSettingsData();
  }
  componentWillUnmount = () => {
    this.setState = (state, callback) => {
      return;
    };
  };
  componentDidUpdate() {
    let mutation;
    let callback;
    let setting = document.querySelector("#settings_class");
    if (setting) {
      callback = (mutations) => {
        mutations.forEach((item, index) => {
          if (item.type === "characterData") {
            this.setState({
              disabledSaveData: false,
            });
          }
        });
      };
    }
    const config = {
      attributes: true,
      // attributesOldValue: true,
      characterData: true,
      // characterDataOldValue: true,
      childList: true,
      subtree: true,
    };
    mutation = new MutationObserver(callback);
    // 开始检测
    mutation.observe(setting, config);
    // 停止检测
    if (!this.state.disabledSaveData) {
      mutation.disconnect();
    }
  }
  //提示弹窗
  toggleToast = (showToastText, showToastIserror = false) => {
    this.setState(({ showToast }) => ({
      showToast: !showToast,
      showToastText: showToastText,
      showToastIserror: showToastIserror,
    }));
  };

  getUserSettingsData = async () => {
    const params = { type: "billing" };
    const response = await reqGetUserSettings(params);

    if (response.code === "200") {
      var result = response.data.userSetting;
      this.setState({
        PayPalUserData: result.PayPalInfo,
        PayoneerData: result.Payoneer,
        loadingPage: false,
      });
    } else {
      this.toggleToast(response.msg);
    }
  };

  // checkbox change
  handleCheckboxChange = (value, id) => {
    this.setState({
      [id]: value,
    });
  };

  // 语言设置
  handleSelectChange = (value) => {
    this.setState({
      selected: value,
      isLanguageChange: true,
    });
  };

  // handle auth modal 速卖通用户授权弹窗
  handleAuthModalChange = () => {
    this.setState({
      authorizeModalActive: true,
    });
  };

  // 回调关闭弹窗
  callBackHandleAuthModalClosed = () => {
    this.setState({
      authorizeModalActive: false,
      needSetPasswordActive: false,
    });
  };

  // 授权按钮disabled
  handleAuthButtonDisable = () => {
    this.setState({
      AuthButtonDisable: true,
      authorizeModalActive: false,
    });
  };

  // 取消授权弹窗提示
  handleDisconnectModal = (type, bool) => {
    // this.setState(({ disconnectActive }) => ({ disconnectActive: !disconnectActive }));
    this.setState({
      disconnectType: type,
      disconnectActive: bool,
    });
  };

  // 取消授权
  handleDisconnectAuth = async () => {
    const { disconnectType } = this.state;
    if (disconnectType === 0) {
      this.toggleToast("Something wrong.", true);
      return;
    }

    this.setState({ AuthButtonDisable: true });

    const params = {};
    var response;
    if (disconnectType === 1) {
      response = await reqGetDisconnect(params);
    } else {
      response = await reqPostDisConnetPayPal(params);
    }

    if (response.code === "200") {
      this.setState({ AuthButtonDisable: false, loadingPage: true });
      this.handleDisconnectModal(0, false);
      // 刷新页面信息
      this.getUserSettingsData();
    } else {
      this.setState({ AuthButtonDisable: false });
      // this.toggleToast(response.msg);
      store.dispatch(changeBannerData({bannerData:{
        show:true,
        desc:response.msg
      }}));
    }
  };

  // 关闭Shopify升级弹窗
  closeShopifyPermissionUpgrade = () => {
    this.setState({ shopify_permission_upgrade: false });
  };
  //payonner 授权
  handlePayonnerAuth = async () => {
    let params = {
      type: AppBridge.exist() ? 1 : 2,
    };
    this.setState({
      payonnerButton: true,
    });
    if (this.state.payonnerLink !== "") {
      window.open(this.state.payonnerLink, "_blank");
      this.setState({
        payonnerButton: false,
      });
      return;
    }
    let res = await getPayonnerAuth(params);
    if (res.code === "200") {
      this.setState({
        payonnerLink: res.data.authorization_url,
      });
      window.open(res.data.authorization_url, "_blank");
    }
    this.setState({
      payonnerButton: false,
    });
  };
  // 取消授权
  handlePayonnerDisconnectAuth = async () => {
    this.setState({
      payonnerOffLoading: true,
    });
    let res = await getPayonnerAuthOff();
    if (res.code === "200") {
      this.setState({
        payonnerLink: "",
        payonnerOff: false,
        PayoneerData: {
          account_id: "",
          email: "",
          expire_time: 0,
          status: 0,
        },
      });
    }
    this.setState({
      payonnerOffLoading: false,
    });
  };
  handlePayonnerAuthOff = () => {
    this.setState({
      payonnerOffLoading: false,
      payonnerOff: false,
    });
  };
  render() {
    const toastMarkup = this.state.showToast ? (
      <Toast
        content={this.state.showToastText}
        onDismiss={() => this.toggleToast("")}
        error={this.state.showToastIserror}
      />
    ) : null;
    const {
      disconnectActive,
      PayPalUserData,
      disconnectType,
      PayoneerData,
      payonnerButton,
    } = this.state;

    const initSkeletonPage = (
      <div className="SettingsPage__Content">
        <Layout>
          <Layout.Section>
            <Card>
              <BlockStack gap={400}>
                <SkeletonBodyText lines={3} />
                <SkeletonBodyText lines={3} />
                <SkeletonBodyText lines={3} />
                <SkeletonBodyText lines={3} />
                <SkeletonBodyText lines={3} />
                <SkeletonBodyText lines={3} />
              </BlockStack>
            </Card>
          </Layout.Section>
        </Layout>
      </div>
    );

    const disconnectModal = (
      <Modal
        open={disconnectActive}
        onClose={() => this.handleDisconnectModal(0, false)}
        title={
          disconnectType === 1
            ? intl.get("Cleanup authorized from AliExpress")
            : intl.get("Cleanup authorized from PayPal")
        }
        primaryAction={{
          content: intl.get("Disconnect"),
          onAction: this.handleDisconnectAuth,
          loading: this.state.AuthButtonDisable,
        }}
        secondaryActions={[
          {
            content: intl.get("Cancel"),
            onAction: () => this.handleDisconnectModal(0, false),
          },
        ]}
      >
        <Modal.Section>
          <p>
            {disconnectType === 1
              ? intl.get("Are you sure cleanup authorized from AliExpress?")
              : intl.get("Are you sure cleanup authorized from PayPal?")}
          </p>
        </Modal.Section>
      </Modal>
    );

    const disconnectPayonnerModal = (
      <Modal
        open={this.state.payonnerOff}
        onClose={() => this.handlePayonnerAuthOff()}
        title={intl.get("Revoke Payoneer Authorization")}
        primaryAction={{
          content: intl.get("Apply"),
          onAction: this.handlePayonnerDisconnectAuth,
          loading: this.state.payonnerOffLoading,
        }}
        secondaryActions={[
          {
            content: intl.get("Cancel"),
            onAction: () => this.handlePayonnerAuthOff(),
          },
        ]}
      >
        <Modal.Section>
          <p>
            {intl.get("Are you certain about revoking the authorization for your Payoneer account?")}
          </p>
        </Modal.Section>
      </Modal>
    );

    const pageContent = this.state.loadingPage ? (
      initSkeletonPage
    ) : (
      <div className="SettingsPage__Content">
        <section className="Panel_Content">
          <BlockStack gap={400}>
            <Card>
              <Text variant="headingMd" as="h2">
                {intl.get("PayPal account")}
              </Text>
              <div
                style={{ display: "flex", marginBottom: "20px" }}
                className="PricingRules__Label"
              >
                <div style={{ fontSize: "14px" }}>
                  {intl.get(
                    "Authorize Dropshipman to add tracking numbers to your transaction on PayPal."
                  )}
                </div>
                <div
                  style={{
                    cursor: "pointer",
                    width: "16px",
                    marginTop: "-4px",
                  }}
                >
                  <Tooltip
                    content={intl.get(
                      "In order to ensure that your Tracking Number can be synced normally, please authorize the binding of your PayPal account to the Shopify store."
                    )}
                    preferredPosition="above"
                  >
                    <Icon source={QuestionCircleIcon} backdrop={true} />
                  </Tooltip>
                </div>
              </div>

              <div className="Profile_Table">
                <table>
                  <thead>
                    <tr>
                      <th>{intl.get("Account")}</th>
                      <th style={{ textAlign: "left" }}>
                        {intl.get("Status")}
                      </th>
                      <th>{intl.get("Action")}</th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr>
                      <td style={{ padding: "10px" }}></td>
                      <td></td>
                      <td></td>
                    </tr>
                    <tr>
                      <td>
                        {PayPalUserData.email !== "" && (
                          <span>
                            <img
                              style={{
                                width: "16px",
                                height: "19px",
                                marginRight: "15px",
                              }}
                              alt=""
                              src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAsCAYAAAAJpsrIAAAAAXNSR0IArs4c6QAABY1JREFUWEfNWGtsFFUU/s48drel2CJgxe5uCpSiSM1ueZREScpDSQBBQEtU5FFolxAgGiBNxKjxkewEiAbDDxIivmKMqJEoaiBBEkPUEqUarCgSgVYCEYXtg3Z3HsdsC7Tbzs6dWfjhze6v853v+/bOuWfOXsL/dJGtr+q9ASQufgBgHhiKZ++EqwASvV86A+AYiBpRHDiELzcm3fDZG6vUVsHiN90QeMIQ/gawG2rB62hc/49Trr2xqPYGmNd7EvUGPgNJXogft/ycLS2LsfghMGZ70/KM7gApVTi+udku095YJN4KoMSzlOcEakLR1Ck4MsMYmDrY2P3aUHRym2eNXBNkWoQfGj4VG4tsnwIYjbnqeM4j+gjHGx4TG4tqT4H5Hc8COSfQCTQ1VIiNVcZfhYVnc9bxmkh0CccbRoqNReKfAFgk4lclC4qVBFiETMep58OQwRLBZAkGS9cS6U80NYwRG4tqzWC+x0lOIYbV3gJYlhtXthiSVZB/6ElDGXICTVsFNVb9tYJE41Uwq06KeehGsu1Czqb6J9LwEUdpTeybRcOCz+2rIfN6LLNdTNbGw+CTIsV8sx3dnY5vFBHFjbhSNe2MWT2zlIDPjFh4gb2xyLaFgDmopwxUCeiXkOrqcC3uBFSX18IYdWcPRJJQq9eF916ryn5pUa0BzHGRotL5FyxTF8GEcdXnh/HMphs4ApqNWPheO2NvgXmFE6NEDCTOCkXdAAIV9yE5d34GVJWV0u41d53NrLFI/DsAVU6kPjJhJFrc6DpiJFkG1j8NDvgzcCRJs4y64OFMY9H4FTAKnRgDlEIqcf6mjQUmViA57+HBPJL8iFlXsr/P2KTXRsFMChXzuRPd7el5L/flLyxCau06WwKS5IeMupJD/YxpM2DyYZFcQL+MVFd6as5tpQveql0Nq7DIlkDxUXlyVehUn7GItg7gXSI5tesCTL1bBLON+4YUwFy+AtZtWaqF0D2+KFTYXEOpPmPR+E4wNjgqpl95iXMgeHsVkSTBXzYOqbnzwf7MYu+vR8BBIxaek9kuotpBMD/oZEwlC2binOvdUlQVvlAIqepZMEcOGiAG8RCw2YiFd2Qai2gtAAedT6QOve08FJ8vEyYRJFkBFBVSQQH4jmJYo0uhl5W7/hEAdJ8qj+2qLenpRb2PsnpXAa60t4tY8gMMfcn87DUiInCMS3vNWLD2OqTXWFSbDOZjIt78iWOQnD5NBMshTh0KfJFkrPh0prHKbctgme+KGP2zq2CMGyuCeY5LJC3X64MZ+r07FtFeAXiriFFeuRjIC4hgnuJE9IJRH3ppYNL1R/kxmBc7McoSAbHHPYk6gonaJaYNeiz4th3umrH4L2BMcCLy56swVgyagHMwSh0gfi9A/hc764ovZiMgpMfpK993AhjQAzJT8kYWIvXoPHdGKD0isw6mDoDbCHQW4J9Yko6OKuQDrTWhLhERYeqOcqT030TAvPIQUrOmi2AgkjaVBkt2/TGXXF03Zd+xqLYAzPtFioEHItArHJ82CHTSiIUc/2GJdPrahctxWq2ZA2v4cAEvvW/GQk+6FXfCESLx9PC/0hFEgLT2CaEeAc8bsfDLQqALACGqfQtmx3bu88kwVy91QSfVmLHgPhdAISS9Y/8CGObYKm4vuGQsXTBCxCbLqEitCZ8Q4dzE0zv2FZh7ZqCsJ2T8mCPSzGnVjoRE5uhgcMjNnsa+4mcmVO4Iwy/b3y4CkJct3AlVsfnnkGH1tBkLl7nZDTeYrGb6Jyu7W35l8N3OB4Q+N+pDIvNuPPVghMYm7Wa1Ca1XAXa87yei7UZ9aItrZVHjERH597SUGSafEuEg0RKzLpS+W7slS7hjEz5k3++XW79gwH5OJjYAOmDUBTcSpe8Pbs36D3DOpzw0MGg9AAAAAElFTkSuQmCC"
                            />
                            {PayPalUserData.email}
                          </span>
                        )}
                      </td>
                      <td>
                        {PayPalUserData.status === 1 &&
                        PayPalUserData.is_effective === 1 ? (
                          <Badge tone="success">{intl.get("Connected")}</Badge>
                        ) : (
                          PayPalUserData.status === 1 &&
                          PayPalUserData.is_effective === 0 && (
                            <Badge tone="warning">{intl.get("invalid")}</Badge>
                          )
                        )}
                      </td>
                      <td style={{ textAlign: "center" }}>
                        {PayPalUserData.status === 1 &&
                        PayPalUserData.is_effective === 1 ? (
                          <Button
                            size="slim"
                            onClick={() => this.handleDisconnectModal(2, true)}
                          >
                            {intl.get("Disconnect")}
                          </Button>
                        ) : (
                          <Button
                            size="slim"
                            variant="primary"
                            url={
                              PayPalUserData.authUrl
                                ? PayPalUserData.authUrl
                                : "#"
                            }
                            external
                          >
                            {intl.get("Connect to PayPal")}
                          </Button>
                        )}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </Card>
            <Card>
              <Text variant="headingMd" as="h2">
                {intl.get("Payoneer Account")}
              </Text>
              <div
                style={{ display: "flex", marginBottom: "20px" }}
                className="PricingRules__Label"
              >
                <div style={{ fontSize: "14px" }}>
                  {intl.get(
                    "Please link your Payoneer account so that you can make payments smoothly."
                  )}
                </div>
              </div>

              <div className="Profile_Table">
                <table>
                  <thead>
                    <tr>
                      <th>{intl.get("Account")}</th>
                      <th style={{ textAlign: "left" }}>
                        {intl.get("Status")}
                      </th>
                      <th>{intl.get("Action")}</th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr>
                      <td style={{ padding: "10px" }}></td>
                      <td></td>
                      <td></td>
                    </tr>
                    <tr>
                      <td>
                        {PayoneerData.account_id !== "" && (
                          <span>
                            <img
                              style={{
                                width: "19px",
                                height: "19px",
                                marginRight: "15px",
                                verticalAlign: "sub",
                              }}
                              alt=""
                              src="/payoneer/pay_icon.png"
                            />
                            {PayoneerData.account_id}
                          </span>
                        )}
                      </td>
                      <td>
                        {PayoneerData.status === 1 ? (
                          <Badge tone="success">{intl.get("Connected")}</Badge>
                        ) : (
                          PayoneerData.status === 1 && (
                            <Badge tone="warning">{intl.get("invalid")}</Badge>
                          )
                        )}
                      </td>
                      <td style={{ textAlign: "center" }}>
                        {PayoneerData.status === 1 ? (
                          <Button
                            size="slim"
                            onClick={() => this.setState({ payonnerOff: true })}
                          >
                            {intl.get("Disconnect")}
                          </Button>
                        ) : (
                          <Button
                            size="slim"
                            variant="primary"
                            loading={payonnerButton}
                            onClick={() => this.handlePayonnerAuth()}
                          >
                            {intl.get("Connect to Payoneer")}
                          </Button>
                        )}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </Card>
          </BlockStack>
        </section>
      </div>
    );

    return (
      <div className={AppBridge.exist() ? "Setting__Page_Content Content_within" : "Setting__Page_Content Content_outside"} id="settings_class">
        <Page title={intl.get("Settings")} separator>
          <section className="SettingsPage__Box">
            <NavTabs selected="Billing" />
            {pageContent}
          </section>

          {toastMarkup}
          {/* 速卖通取消绑定弹窗 */}
          {disconnectModal}
          {/* 取消payonner授权弹窗 */}
          {disconnectPayonnerModal}
          <div className="space"></div>
        </Page>
      </div>
    );
  }
}

export default connect()(ProfileClass);
